import * as React from 'react';
import { ReactComponent as PhoneContactIconSVG } from '../../assets/icons/mevo/ic-phone-contact-outline.svg';
import IconPattern, { IconProps } from './_IconPattern';

const PhoneContactIconOutline: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={PhoneContactIconSVG} variantPlaces={3} {...props} />;
};

export default PhoneContactIconOutline;
